import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanMatchFn, Router } from '@angular/router';
import { AuthStore2 } from '@seatix/shared/data-access/auth';
import { map, race, take } from 'rxjs';

export const authGuard: CanMatchFn = () => {
  const authStore = inject(AuthStore2);
  const router = inject(Router);

  return race([
    toObservable(authStore.isGetIdentityLoaded),
    toObservable(authStore.getIdentityError),
  ]).pipe(
    take(1),
    map(() => {
      if (authStore.check()?.authenticated) {
        return true;
      }
      return router.createUrlTree(['/login']);
    }),
  );
};
